<template>
  <div class="container-fluid vehicle-index-page mazda-index-page">
    <div class="vehicle-index-container">
      <div class="listing-page">
        <div class="row">
          <div class="col-lg-12">
            <div id="srp-title" class="vehicles-found-container">
              <h1><span class="srp-title">New Mazda Vehicles in City, US</span></h1>
              <div>
                <span class="vehicles-found"
                  >{{ selectedBrandVehicles.length || "" }} vehicles available
                  for sale</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="row vehicle-sort-menu" role="complementary">
          <div class="col-md-3 col-md-offset-9 col-xs-12">
            <div class="text-center">
              <div class="btn-group" role="group">
                <button
                  id="mobile-refine-results"
                  class="btn btn-default visible-sm visible-xs"
                  aria-controls="sticky-menu-container"
                  aria-haspopup="listbox"
                  aria-expanded="false"
                >
                  Refine Results
                </button>
                <div class="btn-group">
                  <button
                    id="sortResultsDropdown"
                    class="btn btn-default dropdown-toggle"
                    aria-expanded="false"
                    aria-controls="sort-results"
                    aria-haspopup="listbox"
                    data-toggle="dropdown"
                    type="button"
                  >
                    Sort Results
                  </button>
                  <ul
                    id="sort-results"
                    class="dropdown-menu"
                    aria-labelledby="sortResultsDropdown"
                    role="listbox"
                  >
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Discount: Highest First</span>
                      </a>
                    </li>
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Price: Lowest First</span>
                      </a>
                    </li>
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Price: Highest First</span>
                      </a>
                    </li>
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Mileage: Lowest First</span>
                      </a>
                    </li>
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Year: Newest First</span>
                      </a>
                    </li>
                    <li role="option">
                      <a class="select-sort" href="#" rel="nofollow">
                        <span class="sort-hidden">Year: Oldest First</span>
                      </a>
                    </li>
                  </ul>
                  <!--<button class="btn btn-default" id="toggle-model-search">
                    <i class="fa fa-car"></i>
                  </button>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <SideFilterMenu :headerColor="brandColors['--primary-color']" :brand="brand" />
          <div
            class="col-lg-10 col-md-9 col-sm-12"
            id="vehicles"
            role="main"
            aria-labelledby="srp-title"
            tabindex="-1"
          >
            <MazdaGridVehicle
              v-for="vehicle in selectedBrandVehicles"
              :key="`vehicle-${vehicle.modelName}`"
              v-bind="{
                vehicle,
                price: getRandomPrice(),
                brandColors,
              }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import SideFilterMenu from "./srp-child-components/SideFilterMenu.vue";
import MazdaGridVehicle from "./srp-child-components/MazdaGridVehicle.vue";

export default {
  name: "mazda-approved-search-results",
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      prices: [
        {
          market: 39488,
          belowMarket: 36284,
        },
        {
          market: 49583,
          belowMarket: 44413,
        },
        {
          market: 27995,
          belowMarket: 24089,
        },
        {
          market: 36999,
          belowMarket: 32494,
        },
      ],
    };
  },
  computed: {
    ...mapState(["chosenBrand", "chosenComponents", 'buttonComponents']),
    ...mapGetters(["brandData", "selectedBrandVehicles"]),
    isLockedPricingSelected() {
      return !!this.chosenComponents.find((c) => c.title === "Locked Pricing");
    },
    priceBtn() {
      let component = this.chosenComponents.find(c => c.type === 'get-price-btn')
      if (!component) {
        component = this.findDefaultButton()
      }
      return component
    },
    selectedPriceBtn() {
      const brandBtn = this.priceBtn.previews.find((p) =>  {
        for (var i = 0; i < p.brands.length; i++) {
          if (p.brands[i].toLowerCase() === this.brand.toLowerCase()) {
            return p
          }
        }
      })
      if (brandBtn) {
        return brandBtn
      }
      return this.priceBtn.previews.find(c => c.primary)
    },
    brandColors() {
      return this.brandData.colors;
    },
  },
  methods: {
    getRandomPrice() {
      return this.prices[Math.floor(Math.random() * this.prices.length)];
    },
    findDefaultButton() {
      if (this.isLockedPricingSelected) {
        return this.buttonComponents.lockedPricing.find(c => c.type === 'get-price-btn')
      }
      return this.buttonComponents.unlockedPricing.find(c => c.type === 'get-price-btn')
    }
  },
  components: {
    MazdaGridVehicle,
    SideFilterMenu,
  },
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style>
/*srp filter menu*/
.mazda-index-page .vehicle-filter-menu {
  box-shadow: none !important;
}
.mazda-index-page .vehicle-filter-menu .panel .panel-heading {
  border-bottom: 0px;
  background-color: transparent !important;
  text-align: left;
  color: #101010 !important;
  font-size: 16px !important;
}
.mazda-index-page .sort-menu-container .fa-check:before {
  font-family: "Material Icons";
  content: "\e313";
  font-weight: bold;
  font-size: 17px;
}
.mazda-index-page .sort-menu-container .fa-plus:before {
  font-family: "Material Icons";
  content: "\e313";
  font-weight: bold;
  font-size: 17px;
}
.mazda-index-page .sort-menu-container a.filter-button.section-heading {
  color: #333 !important;
  font-size: 15px !important;
  text-transform: uppercase;
  border-bottom: solid 1px #d2d2d2;
  padding: 5px 0px 15px 0px;
  margin-left: 3px;
  line-height: 1.428571429;
}
.mazda-index-page .sort-menu-container a.filter-button.section-heading.active i {
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.mazda-index-page .sort-menu-container a.filter-button.section-heading.active i {
  transform: rotate(180deg);
}
.mazda-index-page .vehicle-filter-menu .filter-list {
  padding: 0 !important;
}
.mazda-index-page .vehicle-filter-menu .filter-section .filter-list label {
  padding-left: 3px;
}
.mazda-index-page .sort-menu-container > .row.visible-xs.visible-sm {
  margin-top: 15px;
}
.mazda-index-page .sort-menu-container > form[action="/vehicles"] {
  margin-bottom: 10px;
}
body .mazda-index-page .vehicle-filter-menu .panel .panel-body, 
body .mazda-index-page .vehicle-search-menu .panel .panel-body {
  padding: 0 25px 50px 10px;
  background: transparent;
}
.mazda-index-page button#mobile-refine-results {
  border: 0px;
  color: #ffffff;
  border-radius: 3px;
  padding: 8px 15px;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
}
.mazda-index-page button#mobile-refine-results:hover, 
.mazda-index-page button#mobile-refine-results:active, 
.mazda-index-page button#mobile-refine-results:focus {
  color: #ffffff;
  outline: none;
}
.mazda-index-page .vehicle-filter-menu .back-to-top {
  text-transform: none !important;
  font-size: 17px !important;
  letter-spacing: 0px !important;
}

@media (max-width: 991px) {
  .mazda-index-page .sort-menu-container {
    position: relative;
  }
  .mazda-index-page .listing-page .col-lg-12 {
    padding: 0px;
  }
  .mazda-index-page .sort-menu-container button {
    color: rgba(0, 0, 0, 0.87);
    border-color: rgba(0, 0, 0, 0.87);
    background-color: transparent;
    font-weight: 700;
    max-width: 250px;
    margin: 0px auto;
    text-transform: uppercase;
  }
  .mazda-index-page .sort-menu-container button:hover,
  .mazda-index-page .sort-menu-container button:focus {
    color: #fff;
    background-color: rgba(0, 0, 0, 0.87);
    border-color: rgba(0, 0, 0, 0.87);
    outline: none;
  }
  .mazda-index-page .vehicle-filter-menu.hidden-sm.hidden-xs {
    display: block !important;
    height: 0;
  }
}

/*range filter*/

.mazda-index-page .vehicle-filter-menu .irs-bar {
  background: var(--primary-color);
  border-color: var(--primary-color);
}

/* Vehicles found */
.mazda-index-page .vehicles-found-container h1 {
  margin: 0 15px 0 0;
  display: inline-block;
  max-width: 50%;
  font-size: 18px;
}
.mazda-index-page .vehicles-found-container div {
  float: right;
  max-width: calc(50% - 15px);
  text-align: right;
}

@media (min-width: 992px) {
  .mazda-index-page .vehicles-found-container h1 {
    flex-grow: 1;
    font-size: 18px;
    margin: 0 15px 0 0;
    font-weight: 400;
  }
}

/* listing page */
.mazda-index-page .listing-page>.row {
  position: relative;
}
.mazda-index-page .listing-page>.row:first-child {
  display: table;
  width: 100%;
  margin: 0;
}
.mazda-index-page .listing-page>.row:first-child::before,
.mazda-index-page .listing-page>.row:first-child::after {
  display: block;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}
.mazda-index-page .listing-page>.row:first-child::before {
  left: -100%;
}
.mazda-index-page .listing-page>.row:first-child::after {
  right: -100%;
}

/* media queries */

@media (min-width: 992px) {
  .mazda-index-page .sticky-side-menus {
    width: 100%;
  }
  .mazda-index-page .filer-panel {
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .mazda-index-page .vehicle-sort-menu::before {
    display: block;
    position: absolute;
    top: 0;
    left: calc(10px - 5%);
    width: calc(220px + 5%);
    height: 100%;
  }
  .mazda-index-page .listing-page>.row:last-child {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
  }
  .mazda-index-page .listing-page>.row:last-child::before {
    display: block;
    position: absolute;
    top: 0;
    left: calc(10px - 5%);
    width: calc(10px + 5%);
    height: 100%;
  }
  .mazda-index-page .row.vehicle-sort-menu+.row>div[class*="col-"] {
    display: inline-grid;
  }
  .mazda-index-page .vehicle-filter-menu a.section-heading .selected-icon {
    float: right;
    color: #333333;
  }
}

@media (max-width: 991px) {
  .mazda-index-page .vehicles-found-container {
    padding: 15px !important;
    color: #ffffff;
    background-color: #000000;
  }
  .mazda-index-page .sort-menu-container {
    position: relative;
  }
  .mazda-index-page .row.vehicle-sort-menu > .col-md-3 > .text-center {
    text-align: center;
  }
  .mazda-index-page .listing-page .col-lg-12 {
    padding: 0px;
  }
  .mazda-index-page .listing-page > .row:nth-child(3) > [class*="col-"]:first-child {
    padding: 15px;
  }
  .mazda-index-page button#mobile-refine-results {
    color: rgba(0, 0, 0, 0.87);
    background-color: transparent;
    border-color: rgba(0, 0, 0, 0.87);
    font-weight: 700;
    font-family: var(--bold-text);
    font-size: 10.5px;
    text-transform: uppercase;
  }
  .mazda-index-page button#mobile-refine-results:hover,
  .mazda-index-page button#mobile-refine-results:focus {
    color: #fff;
    background-color: rgba(0, 0, 0, 0.87);
    border-color: rgba(0, 0, 0, 0.87);
    outline: none;
  }
  .mazda-index-page .sort-menu-container button {
    color: rgba(0, 0, 0, 0.87);
    border-color: rgba(0, 0, 0, 0.87);
    background-color: transparent;
    font-weight: 700;
    font-family: var(--bold-text);
    max-width: 250px;
    margin: 10px auto;
    text-transform: uppercase;
  }
  .mazda-index-page .sort-menu-container button:hover,
  .mazda-index-page .sort-menu-container button:focus {
    color: #fff;
    background-color: rgba(0, 0, 0, 0.87);
    border-color: rgba(0, 0, 0, 0.87);
    outline: none;
  }
  .mazda-index-page .vehicle-filter-menu.hidden-sm.hidden-xs {
    display: block !important;
    height: 0;
  }
}

/*not media queries*/
.mazda-index-page .vehicle-index-container {
  margin: auto;
}
.mazda-index-page .listing-page {
  padding-top: 0;
  padding-bottom: 30px;
}
.mazda-index-page .mobile-shortcut-btns {
  display: none !important;
}
.mazda-index-page .vehicles-found-container .vehicles-found {
  font-weight: bolder;
  font-family: var(--bold-text);
}
.mazda-index-page span.vehicles-found + span {
  font-weight: 400;
}
.mazda-index-page .vehicle-index-page a:hover,
.mazda-index-page .vehicle-index-page a:focus {
  color: var(--primary-color);
  text-decoration: none;
  outline: none;
}
.mazda-index-page {
  position: relative;
  background: #f2f2f2;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  -moz-font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
}
.vehicle-index-page.mazda-index-page h1 {
  font-family: var(--heading-text);
}
.vehicle-index-page.mazda-index-page h2,
.vehicle-index-page.mazda-index-page h3,
.vehicle-index-page.mazda-index-page h4, 
.vehicle-index-page.mazda-index-page h5, 
.vehicle-index-page.mazda-index-page h6 {
  font-family: var(--subheading-text);
}
.mazda-index-page .listing-page {
  background: transparent !important;
}
.mazda-index-page .listing-page .col-lg-12 {
  padding: 0;
}
.mazda-index-page .listing-page > .row:nth-child(2) {
  margin-top: 0;
}
.mazda-index-page .listing-page > .row:first-child::before,
.mazda-index-page .listing-page > .row:first-child::after, 
.mazda-index-page .vehicles-found-container, 
.mazda-index-page .listing-page>.row:first-child, 
.mazda-index-page .listing-page .col-lg-12 {
  background: #fff;
  color: var(--primary-dark);
}
.mazda-index-page .vehicles-found-container {
  padding: 15px 0;
  color: var(--primary-dark);
  position: relative;
  z-index: 1;
}
.mazda-index-page .vehicle-filter-menu .section-divider {
  border-bottom: none;
  min-height: 1px;
  clear: both;
  width: 100%;
  height: 1px;
}

/*back to top*/

.mazda-index-page .section-heading[onclick="window.scrollTo(0, 0);"] {
  position: fixed;
  height: 56px;
  padding: 16px !important;
  width: 56px;
  right: 20px;
  bottom: 20px;
  border-radius: 50%;
  z-index: 99999999;
  background-color: #333;
  color: #fff !important;
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
      0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
      0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}
.mazda-index-page .section-heading[onclick="window.scrollTo(0, 0);"] > span {
  display: none;
}

/*srp grid view*/
.mazda-index-page #vehicles {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  padding-top: 3px;
}
.mazda-index-page #vehicles>.vehicle-unit-container,
.mazda-index-page .active-template-wrapper {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin: 10px;
  flex-direction: column;
  justify-content: space-between;
  width: calc(100% - 20px);
  background-color: #fff;
}

@media (max-width: 767px) {
  .mazda-index-page .vehicle-index-summary {
    padding-top: 65px;
  }
  .mazda-index-page #call-to-action-overlay {
    font-size: 35px;
  }
}

@media (min-width: 768px) {
  .mazda-index-page #vehicles>.vehicle-unit-container,
  .mazda-index-page .active-template-wrapper {
    width: calc(50% - 20px);
  }
}

@media (min-width: 1200px) {
  .mazda-index-page #vehicles>.vehicle-unit-container,
  .mazda-index-page .active-template-wrapper {
    width: calc(33.333% - 20px);
  }
  .vehicle-index-page.mazda-index-page {
    padding: 0;
  }
}

@media (min-width: 1500px) {
  .mazda-index-page .vehicle-index-container {
    max-width: 1440px;
  }
}

/*srp sort dropdown*/
.mazda-index-page .vehicle-sort-menu {
  background-color: transparent;
  padding: 10px 0;
}
.mazda-index-page .vehicle-sort-menu .text-center {
  text-align: right;
}
.mazda-index-page #sortResultsDropdown {
  background-color: transparent;
  border: none;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  color: rgba(0, 0, 0, 0.87);
  letter-spacing: 1.2px !important;
}
.mazda-index-page .vehicle-sort-menu #sortResultsDropdown {
  color: black;
  font-weight: 500;
}
.mazda-index-page .vehicle-sort-menu #sortResultsDropdown:after {
  font-family: "Material Icons";
  content: "\e313";
  font-weight: bold;
  font-size: 12px;
  margin-left: 5px;
  vertical-align: middle;
}
.mazda-index-page span.caret {
  display: none;
}
.mazda-index-page .vehicle-sort-menu .dropdown-menu {
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: unset;
  -webkit-box-shadow: unset;
  box-shadow: unset;
}
.mazda-index-page .vehicle-sort-menu .dropdown-menu>li>a {
  color: rgba(0, 0, 0, 0.84);
  font-weight: 500;
  padding: 6px 12px;
  letter-spacing: 0px !important;
  text-transform: none !important;
}
.mazda-index-page .vehicle-sort-menu .dropdown-menu>li>a:hover,
.mazda-index-page .dropdown-menu>li>a:focus {
  background-image: none;
  background-color: rgba(0, 0, 0, 0.04);
}
.mazda-index-page #sort-results.dropdown-menu {
  left: unset;
  right: 0;
}
body .mazda-index-page .vehicle-sort-menu #sortResultsDropdown:focus {
  outline: none;
}
</style>